import React from 'react';
import { ModalBody } from 'reactstrap';
import PropTypes from 'prop-types';

import { ReactComponent as CheckRoundIcon } from 'assets/icon-check-round.svg';
import { ReactComponent as WarningIcon } from 'assets/icon-warning.svg';
import { ReactComponent as CloseRoundIcon } from 'assets/icon-close-round.svg';
import { ReactComponent as HourglassIcon } from 'assets/icon-hourglass.svg';

import { colors } from 'shared/defaultTheme';

import { ModalHeader } from '../modal/ModalHeaders';
import { Button } from '../Buttons';
import { AlertModalWrapper, Message } from './styles';

const SUCCESS = 'success';
const WARNING = 'warning';
const ERROR = 'error';
const WAITING = 'waiting';

const colorMap = new Map([
  [SUCCESS, colors.bilbao],
  [WARNING, colors.indochine],
  [ERROR, colors.venetianRed],
  [WAITING, colors.goldenYellow],
]);

const iconMap = new Map([
  [SUCCESS, <CheckRoundIcon className="icon-title" />],
  [WARNING, <WarningIcon className="icon-title" />],
  [ERROR, <CloseRoundIcon className="icon-title" />],
  [WAITING, <HourglassIcon className="icon-title rotating" fill={colors.black} />],
]);

const AlertModal = ({ type, className, isOpen, toggle, message, okText, onOk }) => {
  return (
    <AlertModalWrapper className={className} isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader
        className="modal-header"
        backgroundColor={colorMap.get(type)}
        iconTitle={iconMap.get(type)}
        onClose={toggle}
      />
      <ModalBody>
        <div className="w-100 d-flex flex-row justify-content-center mt-3">
          <Message>{message}</Message>
        </div>
        <div className="w-100 d-flex flex-row justify-content-end mt-4 pr-2">
          <Button
            className="text-uppercase"
            type="button"
            color="primary"
            label={okText}
            onClick={onOk}
          />
        </div>
      </ModalBody>
    </AlertModalWrapper>
  );
};

AlertModal.defaultProps = {
  type: 'success',
  className: '',
  isOpen: false,
  toggle: () => false,
  message: '',
  okText: '',
  onOk: () => false,
};

AlertModal.propTypes = {
  type: PropTypes.oneOf([SUCCESS, WARNING, ERROR]),
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  message: PropTypes.string,
  okText: PropTypes.string,
  onOk: PropTypes.func,
};

export default AlertModal;
